import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';

import { SsrModule } from 'app/constants/ssrModules';
import { Toggle, ToggleSize } from 'app/design-system/components/Toggle';
import { useTranslation } from 'app/lang';
import { asyncQueue } from 'app/lib/asyncQueue';
import useComponentWillMount from 'app/lib/hooks/useComponentWillMount';
import { selectSignalrConnected } from 'app/lib/signalr';

import {
  fetchInterestingMatches,
  INTERESTING_MATCHES_TOPIC,
  showLiveMatches,
  subscribe,
  unsubscribe,
} from './actions';
import Content from './components/Contetnt';
import { onlyLiveMatches, selectSortedSportIds } from './selectors';
import { entityRequested } from './selectors/entities';

import dictionary from './InterestingMatches.dictionary.json';

import styles from './InterestingMatches.module.scss';

export const InterestingMatches = ({
  requested,
  sortedSportIds,
  onlyLiveMatches,
  signalrConnected,
  dispatch,
}) => {
  const { t } = useTranslation();

  useComponentWillMount(() => {
    if (process.env.SERVER && !requested) {
      dispatch(fetchInterestingMatches());
    }
  });

  useEffect(() => {
    return () => {
      asyncQueue.removeFromQueue(INTERESTING_MATCHES_TOPIC, () => dispatch(unsubscribe()));
    };
  }, []);

  useEffect(() => {
    if (signalrConnected) {
      asyncQueue.addToQueue(INTERESTING_MATCHES_TOPIC, () => dispatch(subscribe()));
    }
  }, [signalrConnected]);

  const showOnlyLiveMatches = useCallback(() => {
    dispatch(showLiveMatches());
  }, []);

  if (sortedSportIds.size === 0) {
    return null;
  }

  return (
    <section className={styles.container}
             data-ssr-id={SsrModule.INTERESTING_MATCHES}
             data-test="interestingMatches-container">
      <div className={styles.title}>
        <h5 data-test="interestingMatches-title">{t(dictionary.title)}</h5>
        {sortedSportIds.size > 0 && (
          <label>
            <Toggle active={onlyLiveMatches}
                    data-ga-event="highlights-toggleGoLive"
                    data-ga-event-value={onlyLiveMatches ? 'golive' : 'goline'}
                    size={ToggleSize.SMALL}
                    onChange={showOnlyLiveMatches} />
            <span>{t(dictionary.labelText)}</span>
          </label>
        )}
      </div>
      <Content />
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    requested: entityRequested(state),
    sortedSportIds: selectSortedSportIds(state),
    onlyLiveMatches: onlyLiveMatches(state),
    signalrConnected: selectSignalrConnected(state),
  };
};

export default connect(mapStateToProps)(InterestingMatches);
